import { useEvent } from 'react-use';

export default function useAnyEventAction(callback) {
  useEvent('keydown', callback);
  useEvent('mousemove', callback);
  useEvent('mousedown', callback);
  useEvent('scroll', callback);
  useEvent('touchstart', callback);
}
